import { ScoopDialog, ScoopTextField, ScoopButton, ScoopText, ScoopCheckbox, ScoopSelector, ScoopDatePicker, ScoopSpinner } from '../../../../components/ui'
import { Tooltip } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { useCallback, useEffect } from 'react'
import { APIFilterField } from './APIFilterField'
import { TreeItem, TreeView } from '@mui/x-tree-view'
import { FunctionIcon, RulerIcon, CaretDownIcon, CaretRightIcon } from '@phosphor-icons/react'
import { displayPorperProductNameInDialog } from './APIUIOverrides'
import { debounce } from 'lodash'
import styles from './APIFields.module.scss'

export const APIFields = ({
    dialogOpen,
    APIFeatures,
    stepBack,
    next,
    nextButton,
    onClose,
    fieldList,
    selectedFieldList,
    setSelectedFieldList,
    selectedInbox,
    objectList,
    filterMap,
    setFilterMap,
    reportName,
    selectedObject,
    setReportName,
    handleObjectSelect,
    extractNow,
    setExtractNow,
    startDate,
    setStartDate,
    errorMessage,
    saveLoading,
    server,
    connectorType,
    connectionKey,
    workspaceID,
}) => {
    const [filterField, setFilterField] = React.useState(null)
    const [filterModalOpen, setFilterModalOpen] = React.useState(false)
    const [operator, setOperator] = React.useState('Equals')
    const [numDimensions, setNumDimensions] = React.useState(0)
    const [numMetrics, setNumMetrics] = React.useState(0)
    const [searchText, setSearchText] = React.useState('')
    const [searching, setSearching] = React.useState(false)
    const [filteredFieldList, setFilteredFieldList] = React.useState(fieldList || [])
    const [incompabibleFields, setIncompatibleFields] = React.useState([])

    useEffect(() => {
        if (fieldList) {
            setFilteredFieldList(fieldList)
        }
    }, [fieldList])

    function onFilterModalClose() {
        setFilterModalOpen(false)
    }

    function renderFilterContent(name) {
        var filter = filterMap.get(name)
        if (filter) {
            let filterString = ''
            switch (filter.operator) {
                case 'Equals':
                    filterString = '=' + filter.values[0]
                    break
                case 'NotEquals':
                    filterString = '!=' + filter.values[0]
                    break
                case 'In':
                    filterString = 'In('
                    for (let i = 0; i < filter.values.length; i++) {
                        if (i > 0) filterString += ','
                        filterString += filter.values[i]
                    }
                    filterString += ')'
                    break
                case 'NotIn':
                    filterString = 'NotIn('
                    for (let i = 0; i < filter.values.length; i++) {
                        if (i > 0) filterString += ','
                        filterString += filter.values[i]
                    }
                    filterString += ')'
                    break
                case 'LastDay':
                    filterString = 'Last Day'
                    break
                case 'LastWeek':
                    filterString = 'Last Week'
                    break
                case 'LastMonth':
                    filterString = 'Last Month'
                    break
                case 'LastYear':
                    filterString = 'Last Year'
                    break
            }
            return (
                <div className={styles.filterLinkContainer}>
                    <button
                        className={styles.clearLink}
                        onClick={() => {
                            var newMap = new Map()
                            for (let key in filterMap) {
                                if (key !== name) {
                                    newMap.set(key, filterMap[key])
                                }
                            }
                            setFilterMap(newMap)
                        }}
                    >
                        clear
                    </button>
                    <ScoopText className={styles.filterString}>{filterString}</ScoopText>
                </div>
            )
        } else {
            return ''
        }
    }

    let objectName = 'Object'
    if (APIFeatures) {
        objectName = APIFeatures.objectName ? APIFeatures.objectName : objectName
    }

    function getIncompatibles(newSelectedFields) {
        let list = []
        for (let i = 0; i < newSelectedFields.length; i++) {
            for (let j = 0; j < fieldList.length; j++) {
                if (newSelectedFields[i] === fieldList[j].name) {
                    list.push(fieldList[j])
                    break
                }
            }
        }
        const postJSON = {
            action: 'getAPIIncompatibleFields',
            connectorType: connectorType,
            connectionKey: connectionKey,
            workspaceID: workspaceID,
            object: selectedObject,
            selectedFieldList: list,
        }
        server.postData(postJSON, (results) => {
            setIncompatibleFields(results.fields)
            let newFieldList = fieldList.filter((field) => {
                if (searchText && !field.value.toLowerCase().includes(searchText.toLowerCase()))
                    return false
                for (let i = 0; i < results.fields.length; i++) {
                    if (results.fields[i].name === field.name) {
                        return false
                    }
                }
                return true
            })
            setFilteredFieldList(newFieldList)
            console.log(newFieldList.length)
        })
    }

    function handleCheck(field) {
        let newSelectedFields = []
        let found = false
        for (let i = 0; i < selectedFieldList.length; i++) {
            if (selectedFieldList[i] === field.name) {
                found = true
                if (field.fieldType === 'Dimension') {
                    setNumDimensions(numDimensions - 1)
                } else {
                    setNumMetrics(numMetrics - 1)
                }
            } else {
                newSelectedFields.push(selectedFieldList[i])
            }
        }
        if (!found) {
            if (
                (numDimensions < APIFeatures.maxDimensions && field.fieldType === 'Dimension') ||
                (numMetrics < APIFeatures.maxMetrics && field.fieldType === 'Metric')
            ) {
                if (field.fieldType === 'Dimension') {
                    setNumDimensions(numDimensions + 1)
                } else {
                    setNumMetrics(numMetrics + 1)
                }
                newSelectedFields.push(field.name)
            }
        }
        if (APIFeatures?.getIncompatibleFields) {
            getIncompatibles(newSelectedFields)
        }
        setSelectedFieldList(newSelectedFields)
    }

    let columns = [
        {
            field: 'value',
            headerName: 'Value',
            type: 'string',
            sortable: false,
            editable: false,
            width: selectedObject && selectedObject.fieldsHaveDescriptions ? 150 : 350,
            headerAlign: 'center',
        },
        {
            field: 'filter',
            headerName: 'Filter',
            type: 'string',
            sortable: false,
            editable: false,
            width: selectedObject && selectedObject.fieldsHaveDescriptions ? 150 : 350,
            headerAlign: 'center',
            renderCell: (params) => {
                if (params.value === 'filter') {
                    if (filterMap.get(params.id)) {
                        return <div>{renderFilterContent(params.id)}</div>
                    } else {
                        return (
                            <button
                                className={styles.filterLink}
                                onClick={() => {
                                    for (let i = 0; i < fieldList.length; i++) {
                                        if (fieldList[i].name === params.id) {
                                            setFilterField(fieldList[i])
                                            setFilterModalOpen(true)
                                            if (fieldList[i].fieldType === 'DateTime') {
                                                setOperator('LastDay')
                                            }
                                            break
                                        }
                                    }
                                }}
                            >
                                filter
                            </button>
                        )
                    }
                }
            },
        },
    ]

    if (selectedObject && selectedObject.fieldsHaveDescriptions) {
        columns.push({
            field: 'description',
            headerName: 'Description',
            type: 'string',
            sortable: false,
            editable: false,
            width: 700,
            headerAlign: 'left',
        })
    }

    let dimensionCategories = []
    let metricCategories = []
    if (fieldList) {
        fieldList.forEach((field) => {
            if (field.fieldType === 'Dimension') {
                if (!dimensionCategories.includes(field.type)) dimensionCategories.push(field.type)
            }
            if (field.fieldType === 'Metric') {
                if (!metricCategories.includes(field.type)) metricCategories.push(field.type)
            }
        })
    }
    let count = 3

    const debouncedFilter = useCallback(
        debounce((value) => {
            setFilteredFieldList(
                fieldList.filter((field) => field.value.toLowerCase().includes(value.toLowerCase()))
            )
            setTimeout(() => setSearching(false), 100)
        }, 300),
        [fieldList]
    )

    const handleSearchChange = (event) => {
        const value = event.target.value
        setSearchText(value)
        setSearching(true)
        debouncedFilter(value)
    }

    // Convert objectList to options for ScoopSelector
    const objectOptions = objectList.map((object) => ({
        label: object.label,
        value: object.name,
    }))

    return (
        <>
            <ScoopDialog
                open={dialogOpen}
                title={
                    'Dataset from ' +
                    displayPorperProductNameInDialog(APIFeatures?.connectorName) +
                    ' ' +
                    objectName
                }
                onClose={(e, reason) => {
                    if (reason && reason === 'backdropClick') return
                    onClose()
                }}
                actions={
                    <>
                        <ScoopButton variant="text" size="sm" onClick={stepBack}>
                            Back
                        </ScoopButton>
                        <ScoopButton
                            size="sm"
                            disabled={
                                saveLoading ||
                                reportName.trim().length === 0 ||
                                (selectedFieldList.length === 0 && APIFeatures.canSelectFields)
                            }
                            onClick={() => {
                                next()
                            }}
                        >
                            {saveLoading ? <ScoopSpinner size={20} /> : nextButton}
                        </ScoopButton>
                    </>
                }
                maxWidth={1000}
            >
                <ScoopTextField
                    label={'Dataset name'}
                    onChange={(event) => {
                        setReportName(event.target.value)
                    }}
                    disabled={selectedInbox && selectedInbox.extractDefinition}
                    value={reportName}
                />
                <div className={styles.infoBox}>
                    <ScoopSelector
                        label={'Choose ' + objectName + ' to retrieve'}
                        value={selectedObject ? selectedObject.name : ''}
                        disabled={selectedInbox && selectedInbox.extractDefinition}
                        onChange={(e) => {
                            const object = objectList.find((o) => o.name === e.target.value)
                            if (object) handleObjectSelect(object, APIFeatures)
                        }}
                        options={objectOptions}
                    />
                    {errorMessage && <ScoopText className={styles.errorText}>{errorMessage}</ScoopText>}
                    {fieldList && fieldList.length > 0 && !APIFeatures?.isDimensional && (
                        <div>
                            <ScoopText className={styles.searchFieldsLabel}>Search fields</ScoopText>
                            <ScoopTextField
                                value={searchText}
                                onChange={handleSearchChange}
                                type={'text'}
                            />{' '}
                            {APIFeatures?.canSelectFields && (
                                <div className={styles.fieldSearchBox}>
                                    <ScoopText className={styles.sectionTitle}>
                                        Select the fields you would like to retrieve
                                    </ScoopText>
                                    <div className={styles.selectButtonGroup}>
                                        {fieldList.length <= 50 && (
                                            <ScoopButton
                                                onClick={() => {
                                                    setSelectedFieldList(fieldList.map((f) => f.id))
                                                }}
                                            >
                                                Select all
                                            </ScoopButton>
                                        )}
                                        <ScoopButton
                                            onClick={() => setSelectedFieldList([])}
                                        >
                                            Clear selection
                                        </ScoopButton>
                                    </div>
                                </div>
                            )}
                            {!APIFeatures?.canSelectFields && (
                                <ScoopText className={styles.sectionTitle}>Fields found</ScoopText>
                            )}
                            {APIFeatures?.canSelectFields && selectedFieldList.length >= 100 && (
                                <ScoopText className={styles.maxColumnsWarning}>
                                    Maximum columns reached (100). Deselect a field to add a
                                    different one.
                                </ScoopText>
                            )}
                            <DataGrid
                                autoHeight
                                disableRowSelectionOnClick={true}
                                columns={columns}
                                pageSizeOptions={[15]}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            page: 0,
                                            pageSize: 15,
                                        },
                                    },
                                }}
                                rows={filteredFieldList}
                                rowHeight={25}
                                isRowSelectable={(params) => {
                                    if (selectedFieldList.includes(params.row.id)) {
                                        return true
                                    }
                                    if (selectedFieldList.length < 100) {
                                        return true
                                    }
                                    return false
                                }}
                                checkboxSelection={APIFeatures.canSelectFields}
                                rowSelectionModel={
                                    APIFeatures.canSelectFields ? selectedFieldList : []
                                }
                                onRowSelectionModelChange={(ids) => {
                                    if (!searching && ids.length) setSelectedFieldList(ids)
                                }}
                                sx={{
                                    '& .Mui-checked': {
                                        color: '#E50B54',
                                    },
                                    '& .MuiDataGrid-columnHeaders': {
                                        display: 'none',
                                    },
                                }}
                            />
                        </div>
                    )}
                    {fieldList && APIFeatures?.isDimensional && (
                        <div className={styles.treeViewContainer}>
                            <TreeView
                                sx={{
                                    flex: 1,
                                    mb: 1,
                                    width: 900,
                                    textAlign: 'left',
                                    overflow: 'auto',
                                    padding: '8px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    '& .MuiTreeItem-content.Mui-selected': {
                                        backgroundColor: 'transparent !important',
                                    },
                                    '& .MuiTreeItem-content': {
                                        ':hover': {
                                            backgroundColor: 'transparent !important',
                                        },
                                    },
                                    '& .MuiTreeItem-label': {
                                        ':hover': {
                                            backgroundColor: 'transparent !important',
                                        },
                                    },
                                }}
                                defaultExpanded={[1, 2]}
                                defaultCollapseIcon={<CaretDownIcon size={16} />}
                                defaultExpandIcon={<CaretRightIcon size={16} />}
                            >
                                <TreeItem icon={<RulerIcon size={16} />} label={'Dimensions'} nodeId={1}>
                                    {dimensionCategories.map((dimension) => (
                                        <TreeItem
                                            nodeId={'id' + count++}
                                            label={dimension}
                                            sx={{
                                                padding: '0px',
                                            }}
                                        >
                                            {filteredFieldList
                                                .filter(
                                                    (field) =>
                                                        field.fieldType === 'Dimension' &&
                                                        field.type === dimension
                                                )
                                                .map((field) => (
                                                    <TreeItem
                                                        sx={{ height: 22 }}
                                                        nodeId={'id' + count++}
                                                        label={
                                                            <div className={styles.treeItemLabel}>
                                                                <ScoopCheckbox
                                                                    checked={selectedFieldList.includes(
                                                                        field.name
                                                                    )}
                                                                    onChange={() => {
                                                                        handleCheck(field)
                                                                    }}
                                                                    size="sm"
                                                                />
                                                                <Tooltip
                                                                    title={field.description}
                                                                    arrow
                                                                >
                                                                    <span className={styles.treeItemLabelText}>
                                                                        {field.label}
                                                                        {field.description
                                                                            ? ': ' +
                                                                            field.description
                                                                            : ''}
                                                                    </span>
                                                                </Tooltip>
                                                            </div>
                                                        }
                                                    ></TreeItem>
                                                ))}
                                        </TreeItem>
                                    ))}
                                </TreeItem>
                                <TreeItem icon={<FunctionIcon size={16} />} label={'Metrics'} nodeId={2}>
                                    {metricCategories.map((metric) => (
                                        <TreeItem nodeId={'id' + count++} label={metric}>
                                            {filteredFieldList
                                                .filter(
                                                    (field) =>
                                                        field.fieldType === 'Metric' &&
                                                        field.type === metric
                                                )
                                                .map((field) => (
                                                    <TreeItem
                                                        sx={{ height: 22 }}
                                                        nodeId={'id' + count++}
                                                        label={
                                                            <div className={styles.treeItemLabel}>
                                                                <ScoopCheckbox
                                                                    checked={selectedFieldList.includes(
                                                                        field.name
                                                                    )}
                                                                    onChange={() => {
                                                                        handleCheck(field)
                                                                    }}
                                                                    size="sm"
                                                                />
                                                                <Tooltip
                                                                    title={field.description}
                                                                    arrow
                                                                >
                                                                    <span className={styles.treeItemLabelText}>
                                                                        {field.label}
                                                                        {field.description
                                                                            ? ': ' +
                                                                            field.description
                                                                            : ''}
                                                                    </span>
                                                                </Tooltip>
                                                            </div>
                                                        }
                                                    ></TreeItem>
                                                ))}
                                        </TreeItem>
                                    ))}
                                </TreeItem>
                            </TreeView>
                        </div>
                    )}
                </div>
                {APIFeatures?.requireDateRange && (
                    <div className={styles.dateRangeRow}>
                        <ScoopText>Start Date:</ScoopText>
                        <ScoopDatePicker
                            value={startDate}
                            containerSx={{ width: '150px' }}
                            range={false}
                            onChange={(newDate) => {
                                setStartDate(newDate)
                            }}
                        ></ScoopDatePicker>
                    </div>
                )}
                <div className={styles.extractNowRow}>
                    <ScoopCheckbox
                        checked={extractNow}
                        onChange={() => {
                            setExtractNow(!extractNow)
                        }}
                    />
                    <ScoopText className={styles.extractLabel}>Extract data now</ScoopText>
                </div>
            </ScoopDialog>
            {filterField && (
                <APIFilterField
                    APIFeatures={APIFeatures}
                    filterField={filterField}
                    filterModalOpen={filterModalOpen}
                    onFilterModalClose={onFilterModalClose}
                    setFilterField={setFilterField}
                    setFilterModalOpen={setFilterModalOpen}
                    filterMap={filterMap}
                    operator={operator}
                    setOperator={setOperator}
                ></APIFilterField>
            )}
        </>
    )
}
